// Swiper Start //

document.addEventListener('DOMContentLoaded', () => {

  if (typeof Swiper === 'undefined') return;

  const sliders = document.querySelectorAll('.swiper');

  sliders.forEach((slider) => {

    // Wrapper
    const wrapper = slider.closest('.swiper-unit');
    if (!wrapper) return;

    // Base Options
    let options = {
      loop: true,
      speed: 1000,
    };

    // FV Slider
    if (slider.classList.contains('is-fv')) {
      options.effect = 'fade';
      options.speed = 1200;
      options.navigation = {
        nextEl: wrapper.querySelector('.swiper-button-next'),
        prevEl: wrapper.querySelector('.swiper-button-prev')
      };
      options.pagination = {
        el: wrapper.querySelector('.swiper-pagination'),
        clickable: true
      };
      options.autoplay = {
        delay: 4000,
        pauseOnMouseEnter: false
      };
    }

    // Hero Slider
    if (slider.classList.contains('is-hero')) {
      options.effect = 'fade';
      options.speed = 1100;
      options.navigation = {
        nextEl: wrapper.querySelector('.swiper-button-next'),
        prevEl: wrapper.querySelector('.swiper-button-prev')
      };
      options.pagination = {
        el: wrapper.querySelector('.swiper-pagination'),
        clickable: true
      };
      options.autoplay = {
        delay: 3200,
        pauseOnMouseEnter: true
      };
    }

    // Carousel Slider
    if (slider.classList.contains('is-carousel')) {
      options.slidesPerView = 4;
      options.slidesPerGroup = 1;
      options.speed = 1800;
      options.snapToSlideEdge = true;
      options.autoHeight = false;
      options.loop = true;
      options.loopAddBlankSlides = false;
      options.navigation = {
        nextEl: wrapper.querySelector('.swiper-button-next'),
        prevEl: wrapper.querySelector('.swiper-button-prev')
      };
      options.pagination = {
        el: wrapper.querySelector('.swiper-pagination'),
        clickable: true
      };
      options.autoplay = {
        delay: 2200,
        pauseOnMouseEnter: true
      };
      // Responsive
      options.breakpoints = {
        0: {slidesPerView: 1,},
        768: {slidesPerView: 2,},
        1024: {slidesPerView: 4,}
      };
    }

    // Card Slider
    if (slider.classList.contains('is-card')) {
      options.slidesPerView = 4;
      options.slidesPerGroup = 1;
      options.speed = 1800;
      options.snapToSlideEdge = true;
      options.autoHeight = false;
      options.loop = true;
      options.loopAddBlankSlides = false;
      options.navigation = {
        nextEl: wrapper.querySelector('.swiper-card-button-next'),
        prevEl: wrapper.querySelector('.swiper-card-button-prev')
      };
      options.pagination = {
        el: wrapper.querySelector('.swiper-card-pagination'),
        clickable: true
      };
      options.autoplay = {
        delay: 2200,
        pauseOnMouseEnter: true
      };
      // Responsive
      options.breakpoints = {
        0: {slidesPerView: 2,},
        768: {slidesPerView: 3,},
        1024: {slidesPerView: 4,}
      };
    }

    // GSAP Hook
    options.on = {

      init() {
        if (typeof window.playSlideAnimation === 'function') {
          window.playSlideAnimation(this.el);
        }
      },

      slideChangeTransitionStart() {
        if (typeof window.playSlideAnimation === 'function') {
          window.playSlideAnimation(this.el);
        }
      },
    };

    // Init
    new Swiper(slider, options);
  });
  /* すべてのSwiperが生成された後、少し遅らせてScrollTriggerをリフレッシュ */
  if (typeof ScrollTrigger !== 'undefined') {
   setTimeout(() => {
    ScrollTrigger.refresh();
  }, 500); // Swiperの描画が落ち着くのを見計らって500ms（0.5秒）後に実行
 }
});

// Swiper End //